import {
  GET_DETAIL_CHOVAY,
  GET_DETAIL_CHOVAY_SUCCESS,
  GET_DETAIL_CHOVAY_FAILURE,
  GET_LANDONGLAI_CHOVAY_FAILURE,
  GET_LANDONGLAI_CHOVAY_SUCCESS,
  GET_LANDONGLAI_CHOVAY,
  GET_LAIDENNGAY_CHOVAY,
  GET_LAIDENNGAY_CHOVAY_SUCCESS,
  GET_LAIDENNGAY_CHOVAY_FAILURE,
  GET_LICHSUGIAHAN_CHOVAY,
  GET_LICHSUGIAHAN_CHOVAY_SUCCESS,
  GET_LICHSUGIAHAN_CHOVAY_FAILURE,
  POST_GIAHAN_CHOVAY,
  POST_GIAHAN_CHOVAY_SUCCESS,
  POST_GIAHAN_CHOVAY_FAILURE,
  POST_TRABOTGOC_CHOVAY,
  POST_TRABOTGOC_CHOVAY_SUCCESS,
  POST_TRABOTGOC_CHOVAY_FAILURE,
  GET_LICHSUTRABOTGOC_CHOVAY,
  GET_LICHSUTRABOTGOC_CHOVAY_SUCCESS,
  GET_LICHSUTRABOTGOC_CHOVAY_FAILURE,
  POST_THAYDOIKYTHANHTOAN_CHOVAY,
  POST_THAYDOIKYTHANHTOAN_CHOVAY_SUCCESS,
  POST_THAYDOIKYTHANHTOAN_CHOVAY_FAILURE,
  GET_LICHSUDOIKYLAI_CHOVAY_SUCCESS,
  GET_LICHSUDOIKYLAI_CHOVAY_FAILURE,
  GET_LICHSUDOIKYLAI_CHOVAY,
  POST_VAYTHEM_CHOVAY,
  POST_VAYTHEM_CHOVAY_SUCCESS,
  POST_VAYTHEM_CHOVAY_FAILURE,
  POST_THAYDOILAISUAT_CHOVAY,
  POST_THAYDOILAISUAT_CHOVAY_SUCCESS,
  POST_THAYDOILAISUAT_CHOVAY_FAILURE,
  GET_LICHSUVAYTHEM_CHOVAY,
  GET_LICHSUVAYTHEM_CHOVAY_SUCCESS,
  GET_LICHSUVAYTHEM_CHOVAY_FAILURE,
  POST_TATTOAN_CHOVAY,
  POST_TATTOAN_CHOVAY_SUCCESS,
  POST_TATTOAN_CHOVAY_FAILURE,
  POST_TATTOAN_CHODUYET_CHOVAY,
  POST_TATTOAN_CHODUYET_CHOVAY_SUCCESS,
  POST_TATTOAN_CHODUYET_CHOVAY_FAILURE,
  GET_TATTOAN_CHOVAY,
  GET_TATTOAN_CHOVAY_SUCCESS,
  GET_TATTOAN_CHOVAY_FAILURE,
  DELETE_VAYTHEM_CHOVAY,
  DELETE_VAYTHEM_CHOVAY_SUCCESS,
  DELETE_VAYTHEM_CHOVAY_FAILURE,
  DELETE_TRABOTGOC_CHOVAY,
  DELETE_TRABOTGOC_CHOVAY_SUCCESS,
  DELETE_TRABOTGOC_CHOVAY_FAILURE,
  GET_LAIDENKY_CHOVAY,
} from "./actionTypes";

export const getDetailChoVay = (dataSearch) => ({
  type: GET_DETAIL_CHOVAY,
  dataSearch,
});

export const getDetailChoVaySuccess = (data) => ({
  type: GET_DETAIL_CHOVAY_SUCCESS,
  payload: data,
});

export const getDetailChoVayFailure = () => ({
  type: GET_DETAIL_CHOVAY_FAILURE,
});

export const getLanDongLaiChoVay = (dataSearch) => ({
  type: GET_LANDONGLAI_CHOVAY,
  dataSearch,
});

export const getLanDongLaiChoVaySuccess = (data) => ({
  type: GET_LANDONGLAI_CHOVAY_SUCCESS,
  payload: data,
});

export const getLanDongLaiChoVayFailure = () => ({
  type: GET_LANDONGLAI_CHOVAY_FAILURE,
});

export const getLaiDenNgayChoVay = (dataSearch) => ({
  type: GET_LAIDENNGAY_CHOVAY,
  dataSearch,
});

export const getLaiDenKyChoVay = (dataSearch) => ({
  type: GET_LAIDENKY_CHOVAY,
  dataSearch,
});
export const getLaiDenNgayChoVaySuccess = (data) => ({
  type: GET_LAIDENNGAY_CHOVAY_SUCCESS,
  payload: data,
});

export const getLaiDenNgayChoVayFailure = () => ({
  type: GET_LAIDENNGAY_CHOVAY_FAILURE,
});

export const getLichSuGiaHanChoVay = (dataSearch) => ({
  type: GET_LICHSUGIAHAN_CHOVAY,
  dataSearch,
});

export const getLichSuGiaHanChoVaySuccess = (data) => ({
  type: GET_LICHSUGIAHAN_CHOVAY_SUCCESS,
  payload: data,
});

export const getLichSuGiaHanChoVayFailure = () => ({
  type: GET_LICHSUGIAHAN_CHOVAY_FAILURE,
});

export const postGiaHanChoVay = (dataPost, dataSearch) => ({
  type: POST_GIAHAN_CHOVAY,
  dataPost,
  dataSearch,
});

export const postGiaHanChoVaySuccess = (data) => ({
  type: POST_GIAHAN_CHOVAY_SUCCESS,
  payload: data,
});

export const postGiaHanChoVayFailure = () => ({
  type: POST_GIAHAN_CHOVAY_FAILURE,
});

export const postThayDoiKyThanhToanChoVay = (dataPost, dataSearch) => ({
  type: POST_THAYDOIKYTHANHTOAN_CHOVAY,
  dataPost,
  dataSearch,
});

export const postThayDoiKyThanhToanChoVaySuccess = (data) => ({
  type: POST_THAYDOIKYTHANHTOAN_CHOVAY_SUCCESS,
  payload: data,
});

export const postThayDoiKyThanhToanChoVayFailure = () => ({
  type: POST_THAYDOIKYTHANHTOAN_CHOVAY_FAILURE,
});



export const getLichSuDoiKyThanhToanChoVay = (dataPost, dataSearch) => ({
  type: GET_LICHSUDOIKYLAI_CHOVAY,
  dataPost,
  dataSearch,
});

export const getLichSuDoiKyThanhToanChoVaySuccess = (data) => ({
  type: GET_LICHSUDOIKYLAI_CHOVAY_SUCCESS,
  payload: data,
});

export const getLichSuDoiKyThanhToanChoVayFailure = () => ({
  type: GET_LICHSUDOIKYLAI_CHOVAY_FAILURE,
});

export const postTraBotGocChoVay = (dataPost, dataSearch) => ({
  type: POST_TRABOTGOC_CHOVAY,
  dataPost,
  dataSearch,
});

export const postTraBotGocChoVaySuccess = (data) => ({
  type: POST_TRABOTGOC_CHOVAY_SUCCESS,
  payload: data,
});

export const postTraBotGocChoVayFailure = () => ({
  type: POST_TRABOTGOC_CHOVAY_FAILURE,
});

export const getLichSuTraBotGocChoVay = (dataSearch) => ({
  type: GET_LICHSUTRABOTGOC_CHOVAY,
  dataSearch,
});

export const getLichSuTraBotGocChoVaySuccess = (data) => ({
  type: GET_LICHSUTRABOTGOC_CHOVAY_SUCCESS,
  payload: data,
});

export const getLichSuTraBotGocChoVayFailure = () => ({
  type: GET_LICHSUTRABOTGOC_CHOVAY_FAILURE,
});
export const deleteTraBotGocChoVay = (dataPost, dataSearch) => ({
  type: DELETE_TRABOTGOC_CHOVAY,
  dataPost,
  dataSearch,
});

export const deleteTraBotGocChoVaySuccess = (data) => ({
  type: DELETE_TRABOTGOC_CHOVAY_SUCCESS,
  payload: data,
});

export const deleteTraBotGocChoVayFailure = () => ({
  type: DELETE_TRABOTGOC_CHOVAY_FAILURE,
});

export const postVayThemChoVay = (dataPost, dataSearch) => ({
  type: POST_VAYTHEM_CHOVAY,
  dataPost,
  dataSearch,
});

export const postVayThemChoVaySuccess = (data) => ({
  type: POST_VAYTHEM_CHOVAY_SUCCESS,
  payload: data,
});

export const postVayThemChoVayFailure = () => ({
  type: POST_VAYTHEM_CHOVAY_FAILURE,
});

export const postThayDoiLaiSuatChoVay = (dataPost, dataSearch) => ({
  type: POST_THAYDOILAISUAT_CHOVAY,
  dataPost,
  dataSearch,
});

export const postThayDoiLaiSuatChoVaySuccess = (data) => ({
  type: POST_THAYDOILAISUAT_CHOVAY_SUCCESS,
  payload: data,
});

export const postThayDoiLaiSuatChoVayFailure = () => ({
  type: POST_THAYDOILAISUAT_CHOVAY_FAILURE,
});

export const deleteVayThemChoVay = (dataPost, dataSearch) => ({
  type: DELETE_VAYTHEM_CHOVAY,
  dataPost,
  dataSearch,
});

export const deleteVayThemChoVaySuccess = (data) => ({
  type: DELETE_VAYTHEM_CHOVAY_SUCCESS,
  payload: data,
});

export const deleteVayThemChoVayFailure = () => ({
  type: DELETE_VAYTHEM_CHOVAY_FAILURE,
});

export const getLichSuVayThemChoVay = (dataSearch) => ({
  type: GET_LICHSUVAYTHEM_CHOVAY,
  dataSearch,
});

export const getLichSuVayThemChoVaySuccess = (data) => ({
  type: GET_LICHSUVAYTHEM_CHOVAY_SUCCESS,
  payload: data,
});

export const getLichSuVayThemChoVayFailure = () => ({
  type: GET_LICHSUVAYTHEM_CHOVAY_FAILURE,
});

export const postTatToanChoVay = (dataPost, dataSearch) => ({
  type: POST_TATTOAN_CHOVAY,
  dataPost,
  dataSearch,
});

export const postTatToanChoVaySuccess = (data) => ({
  type: POST_TATTOAN_CHOVAY_SUCCESS,
  payload: data,
});

export const postTatToanChoVayFailure = () => ({
  type: POST_TATTOAN_CHOVAY_FAILURE,
});

export const getTatToanChoVay = (dataPost) => ({
  type: GET_TATTOAN_CHOVAY,
  dataPost,
});

export const getTatToanChoVaySuccess = (data) => ({
  type: GET_TATTOAN_CHOVAY_SUCCESS,
  payload: data,
});

export const getTatToanChoVayFailure = () => ({
  type: GET_TATTOAN_CHOVAY_FAILURE,
});

export const postTatToanChoDuyetChoVay = (dataPost, dataSearch) => ({
  type: POST_TATTOAN_CHODUYET_CHOVAY,
  dataPost,
  dataSearch,
});

export const postTatToanChoDuyetChoVaySuccess = (data) => ({
  type: POST_TATTOAN_CHODUYET_CHOVAY_SUCCESS,
  payload: data,
});

export const postTatToanChoDuyetChoVayFailure = () => ({
  type: POST_TATTOAN_CHODUYET_CHOVAY_FAILURE,
});
